import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LocationList from "../Components/Location";
import API from "../Services/MachineMaster"
import moment from "moment";
import API1 from "../Services/Product";
import API2 from "../Services/Location";
const MachineMasterList = () => {
    const [locationId, setLocationId] = useState("");
    const [errors, setErrors] = useState({});
    const [machineName, setMachineName] = useState("");
    const [machineId, setMachineId] = useState("");
    const [machineType, setMachineType] = useState([]);
    const perPage = 10;
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [machineData, setMachineData] = useState([])
    const [id, setId] = useState("")
    const [status, setStatus] = useState("");
    const [createdDate, setCreatedDate] = useState("");
    const [centerName, setCenterName] = useState("")

    const [selectedColor, setSelectedColor] = useState("");
    const [selectedColorName, setSelectedColorName] = useState("");
    const [selectedAnimation, setSelectedAnimation] = useState("");
    const [productTypes, setProductTypes] = useState([]);
    const [products, setProducts] = useState([]);

    const [selectedProductType, setSelectedProductType] = useState("");
    const [selectedProduct, setSelectedProduct] = useState("");
    const [animation, setAnimation] = useState([]);
    const [selectedAnimationName, setSelectedAnimationName] = useState([]);
    const [productName,setProductName] = useState("");
    const [productTypeName,setProductTypeName] = useState("")

    useEffect(() => {
        if (locationId) {
            fetchProductTypes(locationId);
        } else {
            setProductTypes([]);
            setSelectedProductType("");
            setProducts([]);
            setSelectedProduct("");
        }
    }, [locationId]);

    useEffect(() => {
        fetchAnimation();
        fetchColor();
        if (selectedProductType) {
            fetchProducts(selectedProductType);
        } else {
            setProducts([]);
            setSelectedProduct("");
        }
    }, [selectedProductType]);

    const fetchProductTypes = async (locId) => {
        try {
            const response = await API2.getLocationBaseData(locId);
            const details = response?.data?.data;
            setProductTypes(details?.product_type || []);
        } catch (error) {
            handleApiError(error, "Failed to fetch Product Types.");
        }
    };

    const fetchAnimation = async () => {
        try {
            const response = await API.GetAnimation();
            const details = response?.data;
            // console.log('response?.data animation', response?.data);
            setAnimation(details?.animation || []);
        } catch (error) {
            handleApiError(error, "Failed to fetch Animation list.");
        }
    };

    const fetchColor = async () => {
        try {
            const response = await API.GetAnimation();
            const details = response?.data;

            // console.log('response?.data color111', details?.machine_color);
            setMachineType(details?.machine_color || []);
        } catch (error) {
            handleApiError(error, "Failed to fetch Machine Colors.");
        }
    };

    const fetchProducts = async (productTypeId) => {
        try {
            const response = await API1.Get_Product({
                is_active: 1,
                product_type_id: productTypeId,
            });
            setProducts(response?.data?.data || []);
        } catch (error) {
            handleApiError(error, "Failed to fetch Products.");
        }
    };

    const handleApiError = (error, defaultMessage) => {
        if (error.response?.status === 403) {
            window.location.replace("/Login");
        } else if (error.response) {
            toast.error(`Error: ${error.response.data.message}`);
        } else {
            toast.error(defaultMessage);
        }
    };

    const validateFields = () => {
        const newErrors = {};
        if (!locationId) newErrors.locationId = "Location is required";
        if (!selectedProductType) newErrors.selectedProductType = "Product Type is required";
        if (!selectedProduct) newErrors.selectedProduct = "Product is required";
        if (!machineName.trim()) newErrors.machineName = "Machine Name is required";
        if (!machineId.trim()) newErrors.machineId = "Machine ID is required";
        if (!selectedColor) newErrors.selectedColor = "Color is required";
        if (!selectedAnimation) newErrors.selectedAnimation = "Animation is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {
        getMachineData()
    }, [currentPage])

    const handleUpdateMachine = async () => {
        if (!validateFields()) return;
        const payload = {
            // machine_name: machineName,
            // type: machineType,
            // location_id: parseInt(locationId),
            // machine_id: machineId,
              machine_name: machineName,
            type: selectedColor,
            location_id: parseInt(locationId),
            machine_id: machineId,
            animation: selectedAnimation,
            product_id: selectedProduct,
        };
        try {
            const data = await API.updateMachineRecord(id, payload);
            if (data.status === 200) {
                toast.success(data.data.message);
                setTimeout(() => window.location.reload(), 2000);
            } else {
                console.error("Unexpected response:", data);
            }
        } catch (error) {

            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            if (error.response.status === 404) {
                toast.error(`Error: ${error.response.data.message}`);
            }
            if (error.response) {
                toast.error(`Error: ${error.response.data.message}`);

            } else if (error.request) {
                toast.error("No response received from server");
            } else {
                toast.error(`Request failed: ${error.message}`);
            }
        }
    };
    const getMachineData = async () => {
        try {
            const payload = {
                page_number: currentPage,
                page_size: perPage
            };
            const response = await API.getMachineDetail(payload);
            setMachineData(response?.data?.data)
            setTotalRecords(response?.data?.total_record)
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login")
                toast.error("Network error! Please check your internet connection.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };

    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };

    const handleGetData = async (id) => {
        try {
            setId(id);

            const response = await API.getMachineDetail({ id: id });
            console.log('response machine', response?.data?.data[0])
            const fetchedData = response?.data?.data[0]
            if (fetchedData) {
                setLocationId(fetchedData?.location_id)
                setMachineName(fetchedData?.machine_name)

                setMachineId(fetchedData?.machine_id)
                setStatus(fetchedData?.is_active)
                setCreatedDate(fetchedData?.createdAt)
                setCenterName(fetchedData?.location_name)

                setSelectedProductType(fetchedData?.product_type_is)
                setSelectedProduct(fetchedData?.product_id)
                setSelectedColor(fetchedData?.type)
                setSelectedAnimation(fetchedData?.animation_type)

                setSelectedColorName(fetchedData?.color);
                setSelectedAnimationName(fetchedData?.animation_name);
                setProductName(fetchedData?.product_name)
                setProductTypeName(fetchedData?.product_type_name)



            } else {
                toast.error("Failed to fetch machine details.");
            }
        } catch (error) {
            console.log('error', error);
            if (error.status === 404) {
                toast.error('Resource not found');
            }
            else if (error.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };

    const handleStatusToggle = async (id, currentStatus) => {
        const updatedStatus = !currentStatus;
        try {
            const response = await API.UpdateStatus(id, updatedStatus);
            // console.log("response data....", response)
            if (response.status === 200) {
                setMachineData((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(response.data.message);
                getMachineData();
            } else {
                toast.error("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found.');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            toast.error("Failed to update the status. Please try again.");
        }
    };
    return (
        <div className="col-lg-12 grid-margin stretch-card">

            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="card-title mb-0">Total Machines</h4>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-bordered text-center">
                            <thead>
                                <tr>
                                    <th>SrNo</th>
                                    <th>Action</th>
                                    <th>Machine Name</th>
                                    <th>Machine Id</th>
                                     <th>Center name</th>
                                     <th>ProductType</th>
                                     <th>Product</th>
                                    {/* <th>Machine Name</th> */}
                                    <th>Machine Id</th>
                                    <th>Color</th>

                                    <th>Status</th>
                                    <th>Created-Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {machineData && machineData.map((item, index) => (
                                  
                                    <tr key={item.id} data-active={item?.is_active ? "true" : "false"}>
                                        <td>{(currentPage - 1) * perPage + index + 1}</td>

                                        <td>
                                            <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                <ul className="navbar-nav navbar-nav-right">
                                                    <li className="nav-item nav-profile1">
                                                        <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <div className="nav-profile-text1">
                                                                <p className="mb-1 text-black">
                                                                </p>
                                                            </div>
                                                        </span>
                                                        <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                        <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                            <a className="dropdown-item">
                                                                <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalTaxView">
                                                                    View
                                                                </button>
                                                            </a>
                                                            <div className="dropdown-divider"></div>
                                                            <a className="dropdown-item">
                                                                {/* <button className="btn btn-primary btn-sm" onClick={() => handleGetData(item.id)}>Edit</button>{' '} */}
                                                                <button onClick={() => handleGetData(item.id)}
                                                                    className="btn btn-primary btn-sm" type="button"
                                                                    data-bs-toggle="modal" data-bs-target="#myModal"
                                                                >
                                                                    Edit
                                                                </button>
                                                            </a>
                                                            <div className="dropdown-divider"></div>
                                                            <a className="dropdown-item">
                                                                <button
                                                                    className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                    onClick={() => handleStatusToggle(item.id, item.is_active)}>
                                                                    {item.is_active ? "De-Activate" : "Activate"}
                                                                </button>
                                                            </a>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                        <td>{item.machine_name}</td>
                                        <td>{item.machine_id}</td>
                                         <td>{item.location_name}</td>
                                         <td>{item?.product_type_name}</td>
                                         <td>{item?.product_name}</td>
                                        <td>{item.machine_id}</td>
                                        <td>{item?.color}</td>
                                        {/* <td>{item.type}</td> */}

                                        <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                        <td>
                                            {moment(item.createdAt).format("DD-MM-YYYY")}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation example">
                            <ul className="pagination justify-content-center mt-4">
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        Previous
                                    </button>
                                </li>

                                {getPageNumbers().map((page, index) => (
                                    <li
                                        key={index}
                                        className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                    >
                                        {page === "..." ? (
                                            <span className="page-link">...</span>
                                        ) : (
                                            <button className="page-link" onClick={() => handlePageChange(page)}>
                                                {page}
                                            </button>
                                        )}
                                    </li>
                                ))}

                                <li
                                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                >
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
            <section>
                <div className="modal" id="myModal" data-bs-backdrop="static">
                    {/* <div className="modal-dialog"> */}
                        <div className="modal-dialog modal-lg" style={{ width: "1000px" }}>

                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Update Machine Master</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    {/* Location Dropdown */}
                                    <div className="col-md-4">
                                        <LocationList
                                            selectedLocation={locationId}
                                            setSelectedLocation={(location) => {
                                                setLocationId(location);
                                                setErrors((prev) => ({ ...prev, locationId: "" }));
                                            }}
                                        />
                                        {errors.locationId && <small className="text-danger">{errors.locationId}</small>}
                                    </div>

                                    {/* Product Type Dropdown */}
                                    <div className="col-md-4">
                                        <label>Product Type <span className="text-danger">*</span></label>
                                        <select
                                            className="form-select"
                                            value={selectedProductType}
                                            onChange={(e) => setSelectedProductType(e.target.value)}
                                        >
                                            <option value="">Select Product Type</option>
                                            {productTypes.map((type) => (
                                                <option key={type.id} value={type.id}>
                                                    {type.name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.selectedProductType && <small className="text-danger">{errors.selectedProductType}</small>}
                                    </div>

                                    {/* Product Dropdown */}
                                    <div className="col-md-4">
                                        <label>Product <span className="text-danger">*</span></label>
                                        <select
                                            className="form-select"
                                            value={selectedProduct}
                                            onChange={(e) => setSelectedProduct(e.target.value)}
                                        >
                                            <option value="">Select Product</option>
                                            {products.map((product) => (
                                                <option key={product.id} value={product.id}>
                                                    {product.name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.selectedProduct && <small className="text-danger">{errors.selectedProduct}</small>}
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    {/* Machine Name */}
                                    <div className="col-md-3">
                                        <label>Machine Name <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={machineName}
                                            onChange={(e) => setMachineName(e.target.value)}
                                        />
                                        {errors.machineName && <small className="text-danger">{errors.machineName}</small>}
                                    </div>

                                    {/* Machine ID */}
                                    <div className="col-md-3">
                                        <label>Machine ID <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={machineId}
                                            onChange={(e) => setMachineId(e.target.value)}
                                        />
                                        {errors.machineId && <small className="text-danger">{errors.machineId}</small>}
                                    </div>

                                    {/* Color */}
                                    <div className="col-md-3">
                                        <label>Color <span className="text-danger">*</span></label>
                                        <select
                                            className="form-select"
                                            value={selectedColor}
                                            onChange={(e) => setSelectedColor(e.target.value)}
                                        >
                                            <option value="">Select Color</option>
                                            {machineType.map((type) => (
                                                <option key={type.id} value={type.id}>
                                                    {type.name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.selectedColor && <small className="text-danger">{errors.selectedColor}</small>}
                                    </div>

                                    {/* Animation */}
                                    <div className="col-md-3">
                                        <label>Animation <span className="text-danger">*</span></label>
                                        <select
                                            className="form-select"
                                            value={selectedAnimation}
                                            onChange={(e) => setSelectedAnimation(e.target.value)}
                                        >
                                            <option value="">Select Animation</option>
                                            {animation.map((type) => (
                                                <option key={type.id} value={type.id}>
                                                    {type.name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.selectedAnimation && <small className="text-danger">{errors.selectedAnimation}</small>}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-primary" onClick={handleUpdateMachine} >Update</button>
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="modal" id="myModalTaxView" data-bs-backdrop="static">
                    <div className="modal-dialog modal-lg" style={{ width: "800px" }}>
                        <div className="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Machine Master Details</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div className="col-lg-12 grid-margin stretch-card">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-bordered text-center">
                                                    <thead>
                                                        <tr>
                                                            <th>Center</th>
                                                            <th>Product</th>
                                                            <th>Product Type</th>

                                                        </tr>
                                                        <tr>
                                                            <td>{centerName}</td>
                                                            <td>{productName}</td>
                                                            <td>{productTypeName}</td>
                                                            {/* <td>{machineType}</td>
                                                            <td>{machineId}</td> */}
                                                        </tr>
                                                        <tr>
                                                            <th>Machine Name</th>
                                                            <th>Machine Id</th>
                                                            <th>Color</th>

                                                        </tr>

                                                        <tr>
                                                            <td>{machineName}</td>
                                                            <td>{machineId}</td>
                                                            <td>{selectedColorName}</td>

                                                        </tr>


                                                        <tr>
                                                            <th>Animation</th>
                                                            <th>Status</th>
                                                            <th>Created Date</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{selectedAnimationName}</td>
                                                            <td>{status ? "Active" : "De-Activated"}</td>
                                                            <td>{moment(createdDate).format("DD-MM-YYYY")}</td>
                                                        </tr>
                                                    </thead>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default MachineMasterList
